import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
const TONES = {
    neutral: "border-fg/25 bg-transparent text-fg/90",
    primary: "border-primary/40 bg-primary-soft text-primary-strong",
    success: "border-success/40 bg-success/10 text-success",
    warning: "border-warning/40 bg-warning/10 text-warning",
    danger: "border-danger/40 bg-danger/10 text-danger",
};
export function Badge({ tone = "neutral", className, ...rest }) {
    return (_jsx("span", { className: cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", TONES[tone], className), ...rest }));
}
/** "TESTNET" on testnet, "TEST VERSION" on mainnet — always visible (spec §1). */
export function NetworkBadge({ label, className, }) {
    return (_jsx(Badge, { tone: label === "TESTNET" ? "warning" : "danger", className: cn("font-mono tracking-wider", className), "data-testid": "network-badge", children: label }));
}
//# sourceMappingURL=Badge.js.map